import React from 'react';
import TaskCard from './TaskCard';

function TaskList({ tasks, onTaskClick }) {
  return (
    <div className="grid gap-4">
      {tasks.length > 0 ? (
        tasks.map((task) => (
          <TaskCard 
            key={task._id} 
            task={task} 
            onClick={() => onTaskClick(task)} 
          />
        ))
      ) : (
        <div className="text-center text-gray-500">No tasks found.</div>
      )}
    </div>
  );
}

export default TaskList;
